export default "__VITE_ASSET__DuHNb2Qr__"